<template>
    <v-container style="margin-top: 20px;">

        <v-container class="toolbar__container" style="z-index: 1000;">
            <v-form ref="form" v-model="formValidado">
                <v-row>
                    <v-col cols="12" sm="6" md="3">
                        <v-autocomplete v-model="empresaSelected" :items="empresas" item-text="razao_social"
                            item-value="id_empresa" clearable :label="$tc('company.self', 1)"
                            @change="onEmpresaChanged"></v-autocomplete>
                    </v-col>
                    <!-- adicionar unidade -->
                    <v-col cols="12" sm="6" md="3">
                        <MultiplaEscolha 
                            :items="unidadesItens"
                            v-bind:selected-items.sync="unidadesSelecionadas"
                            text="descricao_unidade"
                            value="id_unidade"
                            :label="$t('nav.registration.units')"
                            :max-items="2"
                        />
                    </v-col>
                    <!-- termina unidade -->
                    <v-col cols="12" sm="4" md="3">
                        <v-datetime-picker :label="$t('datetime.startDate')" v-model="dti"
                            :time-picker-props="timeProps" :text-field-props="textFieldProps"
                            :date-picker-props="dtiProps" time-format="HH:mm:ss" date-format="dd/MM/yyyy"
                            :clear-text="$t('datetime.close')">
                            <template slot="dateIcon">
                                <v-icon>mdi-calendar</v-icon>
                            </template>
                            <template slot="timeIcon">
                                <v-icon>mdi-clock</v-icon>
                            </template>
                        </v-datetime-picker>
                    </v-col>
                    <v-col cols="12" sm="4" md="3">
                        <v-datetime-picker :label="$t('datetime.finalDate')" v-model="dtf"
                            :time-picker-props="timeProps" :text-field-props="textFieldProps"
                            :date-picker-props="dtfProps" time-format="HH:mm:ss" date-format="dd/MM/yyyy"
                            :clear-text="$t('datetime.close')">
                            <template slot="dateIcon">
                                <v-icon>mdi-calendar</v-icon>
                            </template>
                            <template slot="timeIcon">
                                <v-icon>mdi-clock</v-icon>
                            </template>
                        </v-datetime-picker>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <v-autocomplete v-model="cercaSelected" :items="cercas" item-text="nome_cerca"
                            item-value="id_cerca" clearable :label="$tc('geofence.self', 1)"
                            @change="onCercaChanged"></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="1" align="end">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn small fab color="primary darken-1" class="white--text" v-bind="attrs" v-on="on"
                                    @click="populaRelatorio" style="margin-bottom: 5px;">
                                    <v-icon>mdi-magnify</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t('operation.search') }}</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
            </v-form>
        </v-container>

        <div id="mapcontainer" ref="mapDiv" style="margin-top: 20px;">
            <v-dialog v-model="loading" width="20%" style="z-index: 1000;">
                <v-card>
                    <v-card-title>
                        <span>{{ $t('relVehicleAreaMap.searchingVehiclesGeofence') }}</span>
                    </v-card-title>
                    <v-card-text>
                        <v-progress-linear height="10" color="primary" indeterminate>
                        </v-progress-linear>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-navigation-drawer v-model="showDrawer" absolute temporary overlay-opacity="0" right dark
                style="width: 40%; z-index: 5000">
                <v-toolbar flat style="border-radius: 10px; margin-top: 5px">
                    <v-text-field v-model="searchVeiculos" append-icon="mdi-magnify"
                        :label="$t('operation.searchVehicle')" single-line hide-details></v-text-field>
                </v-toolbar>
                <v-expansion-panels>
                    <v-expansion-panel v-for="(item, i) in filteredVeiculos" :key="`DRAWER-V-${item}-${i}`"
                        @click="veiculoClicked(item)">
                        <v-expansion-panel-header class="font-weight-bold" style="color: grey">

                            {{ item }}

                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <div v-for="(pos, p) in posicoes.filter((p) => p.numero_ordem === item)"
                                :key="`DRAWER-P-${pos.id_carro}-${p}`">
                                <pre>{{ $t('tracking.latitud') }} : {{ pos.lat }}</pre>
                                <br />
                                <pre>{{ $t('tracking.longitud') }} : {{ pos.lng }}</pre>
                                <br />
                                <pre>{{ $t('datetime.dateSlashHour') }} : {{ pos.dt_posicao_extenso }}</pre>
                                <br />
                                <pre>{{ $t('operation.heading') }} : {{ pos.rumo }}</pre>
                                <br />
                                <pre>{{ $t('operation.speed') }} : {{ pos.velocidade }}</pre>
                                <br />
                                <v-divider></v-divider>
                                <br />
                            </div>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-navigation-drawer>
            <l-map v-if="mapReady" ref="myMap" :zoom="15" :center="currentCenter" :options="mapOptions" @ready="mapIsReady()">
                <l-tile-layer :url="url" :attribution="attribution" />

                <l-control :position="'topright'">
                    <BuscaEndereco @search="(e) => searchAddress(e)" @clear="removeSearchMarker()"></BuscaEndereco>
                </l-control>
                <l-control :position="'topright'">
                    <v-btn small fab @click="showDrawer = true">
                        <v-icon color="black">mdi-bus</v-icon></v-btn>
                </l-control>


                <Vue2LeafletRotatedMarker v-for="(pos, p) in posicoes" :key="`${pos.id_carro}-${p}`"
                    :lat-lng="latLng(pos.lat, pos.lng)" :icon="getIcon(pos)" :rotationAngle="parseInt(pos.rumo)"
                    :rotationOrigin="'15px 15px'">
                    <l-popup :options="{ maxWidth: 'fit-content' }">
                        <pre><b>{{ $t('videowall.code') }} :</b> {{ pos.numero_ordem }}</pre>
                        <pre><b>{{ $t('operation.validatorLine') }} :</b> {{ pos.nome_linha }}</pre>
                        <br />
                        <pre><b>{{ $t('datetime.positionDate') }} :</b> {{ pos.dt_posicao_extenso }}</pre>
                        <pre><b>{{ $t('operation.speed') }} :</b> {{ pos.velocidade }} km/h</pre>
                        <pre><b>{{ $t('operation.heading') }} :</b> {{ pos.rumo }}</pre>
                        <pre><b>{{ $t('operation.direction') }} :</b> {{ pos.descricao_sentido }}</pre>
                        <br />
                    </l-popup>
                    <l-tooltip :content="pos.numero_ordem"
                        :options="{ permanent: true, direction: 'top', opacity: 1.0, className: 'veiculo__tooltip' }"></l-tooltip>
                </Vue2LeafletRotatedMarker>
            </l-map>
        </div>
    </v-container>
</template>

<script>
import apiController from "@/utils/apiController";
// import VueJsonToCsv from "vue-json-to-csv";
// import ExportTablePdf from "./ExportTablePdf.vue";
import DateUtils from "../utils/dateutils";
import L from "leaflet";
import { LMap, LTileLayer, LPopup, LTooltip, LControl } from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import Vue2LeafletRotatedMarker from 'vue2-leaflet-rotatedmarker';
import BuscaEndereco from "./TextFields/BuscaEndereco.vue";
import EventBus from "@/utils/eventBus";
import translateDbField from "@/utils/translateDbField";
import MultiplaEscolha from './Selects/MultiplaEscolha.vue';

export default {
    components: {
        LMap,
        LTileLayer,
        LPopup,
        LTooltip,
        LControl,
        Vue2LeafletRotatedMarker,
        BuscaEndereco,
        MultiplaEscolha
        // VueJsonToCsv,
        // ExportTablePdf,
    },
    data: () => ({
        user: null,
        token: null,
        formValidado: false,
        empresas: [],
        empresaSelected: null,
        unidades: [],
        unidadesSelecionadas: [],
        dti: null,
        dtf: null,
        timeProps: {
            useSeconds: true,
        },
        datasValidadas: false,
        config: null,
        url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        attribution:
            '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        currentCenter: [-22.88746, -43.29185],
        mapReady: false,
        mapOptions: {
            zoomSnap: 0.5,
        },
        map: null,
        drawnItems: null,
        cerca: null,
        cercaValidada: false,
        veiculos: [],
        veiculosSelect: [],
        veiculosCerca: [],
        loading: false,
        posicoes: [],
        showDrawer: false,
        searchVeiculos: "",
        veiculoSelected: null,
        cercas: [],
        cercaSelected: null,
        drawControl: null,
        drawControlLimited: null,
        cercaLayer: null,
        address: "",
        loadingEndereco: false,
        searchMarker: null,
        searchMarkerPos: {
            lat: null,
            lng: null
        },
    }),
    computed: {
        center() {
            return this.$store.getters['config/centerDefault'];
        },
        textFieldProps() {
            return {
                prependInnerIcon: "mdi-calendar",
                rules: [(v) => !!v || this.$t('contract.messages.selectDate')], // (v) => v > this.dtfimbase || "Data início deve ser menor que data fim !"]
            }
        },
        today() {
            return new Date().toISOString().substring(0, 10);
        },
        dtiProps() {
            return {
                max: this.today,
            }
        },
        dtfProps() {
            let min = null;
            if (this.dti) {
                if (typeof this.dti === 'string') {
                    min = `${this.dti.substring(6, 10)}-${this.dti.substring(3, 5)}-${this.dti.substring(0, 2)}`;
                } else {
                    min = this.dti.toISOString().substring(0, 10);
                }
            }
            return {
                min: min,
            }
        },
        dateDiff() {
            let start = typeof this.dti === "string" ?
                new Date(this.dti.substring(6, 10), this.dti.substring(3, 5) - 1, this.dti.substring(0, 2), this.dti.substring(11, 13), this.dti.substring(14, 16), this.dti.substring(17, 19)) :
                this.dti;
            let end = typeof this.dtf === "string" ?
                new Date(this.dtf.substring(6, 10), this.dtf.substring(3, 5) - 1, this.dtf.substring(0, 2), this.dtf.substring(11, 13), this.dtf.substring(14, 16), this.dtf.substring(17, 19)) :
                this.dtf;

            return (end - start) / 3600000;
        },
        filteredVeiculos() {
            if (this.searchVeiculos.length === 0 || this.searchVeiculos === null) {
                return this.veiculosCerca;
            } else {
                return this.veiculosCerca.filter((v) => {
                    return v.toLowerCase().match(this.searchVeiculos.toLowerCase());
                });
            }
        },
        unidadesItens() {
            return this.unidades;
        }
    },
    watch: {
        '$i18n.locale'() {
            this.initialize();
        },
        unidadesSelecionadas() {
            this.onEmpresaChanged();
        }
    },
    created() {
        this.user = JSON.parse(sessionStorage.getItem("user"));
        this.token = sessionStorage.getItem("api");
    },
    mounted() {
        this.initialize();
    },
    methods: {
        initialize() {
            // Garantir que currentCenter seja sempre um array válido
            try {
                if (this.center && Array.isArray(this.center) && this.center.length === 2 && 
                    typeof this.center[0] === 'number' && typeof this.center[1] === 'number') {
                    this.currentCenter = [...this.center];
                }
            } catch (e) {
                console.warn('Error getting center from store:', e);
            }
            
            // Validação final antes de renderizar o mapa
            if (!Array.isArray(this.currentCenter) || this.currentCenter.length !== 2 ||
                typeof this.currentCenter[0] !== 'number' || typeof this.currentCenter[1] !== 'number') {
                this.currentCenter = [-22.88746, -43.29185];
            }
            
            // Agora é seguro renderizar o mapa
            this.mapReady = true;
            
            this.getConfig();
            this.populaEmpresas();
            this.populaVeiculos();
            this.populaCercas();
            this.populaUnidades();
        },
        getConfig() {
          apiController.request(apiController.endpoints.getallConfig, {
            silent: true,
            onSuccess: (response) => {
              this.config = response.data[0];
              [this.dti, this.dtf] = DateUtils.setDefaultDateFilters(this.config.hora_inicial_dia_operacao);
              this.dtf.setDate(this.dtf.getDate() - 1);
              this.dtf.setHours(this.dtf.getHours() + 6);
            },
            onError: (e) => {
              console.log("Response : " + e.message);
              if (e.message == "Request failed with status code 401") {
                EventBus.$emit('show-error', { error: e });
              }
            },
          });
        },
        populaEmpresas() {
            apiController.request(apiController.endpoints.getallEmpresas, {
                silent: true,
                onSuccess: (response) => {
                    this.empresas = response.data;
                },
                onError: (e) => {
                    console.log(this.$t('system.messages.errorAxios'));
                    console.log(e.message);
                    if (e.message == "Request failed with status code 401") {
                        EventBus.$emit('show-error', { error: e });
                    }
                },
            });
        },
        populaVeiculos() {
            apiController.request(apiController.endpoints.getallVeiculosativos, {
                silent: true,
                onSuccess: (response) => {
                    this.veiculos = response.data;
                    this.veiculosSelect = this.veiculos;
                    this.veiculosSelect.forEach((v) => {
                        const translated = translateDbField(
                            v.status_validador_translation_key,
                            v.descricao_status_validador
                        );
                        return {
                            ...v,
                            descricao_status_validador: translated
                        }
                    });
                },
                onError: (e) => {
                    console.log(this.$t('system.messages.errorAxios'));
                    console.log(e.message);
                    if (e.message == "Request failed with status code 401") {
                        EventBus.$emit('show-error', { error: e });
                    }
                },
            });
        },
        populaCercas() {
            apiController.request(apiController.endpoints.getallCercasativas, {
                silent: true,
                onSuccess: (response) => {
                    this.cercas = response.data.map((c) => {
                        if (c.geojson) {
                            c.geojson = JSON.parse(c.geojson);
                        }
                        return c;
                    });
                },
                onError: (e) => {
                    console.log(this.$t('system.messages.errorAxios'));
                    console.log(e.message);
                    if (e.message == "Request failed with status code 401") {
                        EventBus.$emit('show-error', { error: e });
                    }
                },
            });
        },
        populaUnidades() {
            apiController.request(apiController.endpoints.getallUnidadesativas, {
                onSuccess: (response) => {
                    this.unidades = [{ id_unidade: -1, descricao_unidade: 'Sem Unidade', cod_unidade: 'SU' }, ...(response.data || [])];
                },
            });
        },
        mapIsReady() {
            this.map = this.$refs.myMap.mapObject;

            // Tell leaflet that the map is exactly as big as the image
            this.map.setMaxBounds(this.bounds);

            // The view model from Vue Data used in JS
            // This works, since wm refers to your view model.
            // eslint-disable-next-line no-unused-vars
            let vm = this;

            // Leaflet Draw
            // Add new FeatureGroup from leaflet for Draw objects on map
            this.drawnItems = new window.L.FeatureGroup();
            this.map.addLayer(this.drawnItems);

            // Create leaflet draw control menu
            let defaultDrawOptions = {
                position: "topright",
                draw: {
                    polyline: false,
                    polygon: {
                        allowIntersection: false, // Restricts shapes to simple polygons
                        drawError: {
                            color: "orange",
                            timeout: 2000,
                            message: "<strong>Polígono Inválido<strong>",
                        },
                        showArea: true,
                        metric: true, //m2
                        repeatMode: false,
                        shapeOptions: {
                            polylineID: false,
                            color: "#000000",
                            fillColor: "#2196F3",
                            weight: 1,
                            fillOpacity: 0.7,
                            lineCap: "round",
                            lineJoin: "bevel",
                            dashArray: "",
                            opacity: 1,
                        },
                    },
                    rectangle: {
                        allowIntersection: false, // Restricts shapes to simple polygons
                        drawError: {
                            color: "orange",
                            timeout: 2000,
                            message: "<strong>{{$t('relVehicleAreaMap.invalidRectangle')}}<strong>",
                        },
                        showArea: true,
                        metric: true, //m2
                        repeatMode: false,
                        shapeOptions: {
                            polylineID: false,
                            color: "#000000",
                            fillColor: "#2196F3",
                            weight: 1,
                            fillOpacity: 0.7,
                            lineCap: "round",
                            lineJoin: "bevel",
                            dashArray: "",
                            opacity: 1,
                        },
                    },
                    circle: {
                        allowIntersection: false, // Restricts shapes to simple polygons
                        drawError: {
                            color: "orange",
                            timeout: 2000,
                            message: "<strong>{{$t('relVehicleAreaMap.invalidCircle')}}<strong>",
                        },
                        showArea: true,
                        metric: true, //m2
                        repeatMode: false,
                        showRadius: true,
                        shapeOptions: {
                            polylineID: false,
                            color: "#000000",
                            fillColor: "#2196F3",
                            weight: 1,
                            fillOpacity: 0.7,
                            lineCap: "round",
                            lineJoin: "bevel",
                            dashArray: "",
                            opacity: 1,
                        },
                    },
                    marker: false,
                    circlemarker: false,
                },
                edit: {
                    featureGroup: this.drawnItems,
                    remove: true,
                    edit: {
                        // Set color and fill for edited element
                        selectedPathOptions: {
                            color: "#333",
                            fillColor: "#333",
                        },
                    },
                },
            };
            this.drawControl = new window.L.Control.Draw(defaultDrawOptions);
            this.drawControlLimited = new window.L.Control.Draw({
                position: "topright",
                draw: false,
                edit: {
                    featureGroup: this.drawnItems,
                    remove: true,
                    edit: {
                        // Set color and fill for edited element
                        selectedPathOptions: {
                            color: "#333",
                            fillColor: "#333",
                        },
                    },
                },
            });
            // Add all draw shapes on the map
            this.map.addControl(this.drawControl);

            this.map.on("draw:created", function (e) {
                let layer = e.layer;

                let feature = layer.toGeoJSON();
                vm.saveCoords(feature.geometry.coordinates, layer.options.radius);
                if (vm.marker) {
                    vm.drawnItems.removeLayer(vm.marker);
                }
                vm.drawnItems.addLayer(layer);
                vm.map.removeControl(vm.drawControl);
                vm.map.addControl(vm.drawControlLimited);
            });

            this.map.on("draw:deleted", function () {
                vm.deleteCoords();
                vm.map.removeControl(vm.drawControlLimited);
                vm.map.addControl(vm.drawControl);
            });

            this.map.on("draw:edited", function (e) {
                let layers = e.layers;

                let feature = layers.getLayers()[0].toGeoJSON();
                vm.saveCoords(feature.geometry.coordinates);
            });
        },
        saveCoords(coords, radius) {
            if (radius) {
                this.cerca = {
                    type: 'Circle',
                    center: {
                        lat: coords[1],
                        lng: coords[0]
                    },
                    radius: Math.round(radius),
                    points: null
                };
            } else {
                this.cerca = {
                    type: 'Polygon',
                    center: null,
                    radius: null,
                    points: coords[0]
                };
            }
        },
        deleteCoords() {
            this.cerca = null;
        },
        populaRelatorio() {
            this.loading = true;
            this.formValidado = this.$refs.form.validate();
            this.datasValidadas = this.validateDates();
            this.cercaValidada = this.validateCerca();
            this.posicoes = [];

            if (this.formValidado && this.datasValidadas && this.cercaValidada) {
                let body = {
                    idveiculos: this.veiculosSelect.map((v) => v.id_veiculo),
                    dti: DateUtils.getDateSQLFormatted(this.dti),
                    dtf: DateUtils.getDateSQLFormatted(this.dtf),
                    coords: this.cerca
                }

                apiController.request(apiController.endpoints.getVeiculosareamapa, {
                    data: body,
                    onSuccess: (response) => {
                        this.posicoes = response.data;
                        this.populaVeiculosCerca();
                    },
                    onError: () => {
                        this.loading = false;
                    },
                });
            }
        },
        populaVeiculosCerca() {
            this.veiculosCerca = [];
            if (this.posicoes.length > 0) {
                this.veiculosCerca = Array.from(new Set(this.posicoes.map((p) => p.numero_ordem)));
            }
            this.loading = false;
        },
        validateDates() {
            if (this.dateDiff > 6) {
                EventBus.$emit('show-alert', { mensagem: this.$t('datetime.messages.difBethenDates6h'), tipo: 'error' });
                return false;
            }

            return true;
        },
        validateCerca() {
            if (!this.cerca) {
                EventBus.$emit('show-alert', { mensagem: this.$t('geofence.messages.invalidGeofence'), tipo: 'error' });
                return false;
            }

            return true;
        },
        onEmpresaChanged() {
            let veiculosFiltrados = [];
            if (this.empresaSelected) {
                veiculosFiltrados = this.veiculos.filter((v) => v.id_empresa == this.empresaSelected);
            } else {
                veiculosFiltrados = this.veiculos;
            }
            
            // Filtro por unidades selecionadas (Number alinha tipo vindo do select vs API)
            if (this.unidadesSelecionadas.length > 0) {
                const selecionadas = this.unidadesSelecionadas.map((id) => Number(id));
                veiculosFiltrados = veiculosFiltrados.filter((v) => {
                    return selecionadas.includes(Number(v.id_unidade));
                });
            }
            
            this.veiculosSelect = veiculosFiltrados;
        },
        latLng(lat, lng) {
            if (lat != null && lng !== null) {
                if (lat.trim() !== "0") {
                    return L.latLng(lat, lng);
                } else {
                    return L.latLng(-22.88746, -43.29185);
                }
            } else {
                return L.latLng(-22.88746, -43.29185);
            }
        },
        getIcon(pos) {
            let color = "none";
            let width = "30";
            let height = "30";

            if (pos.sentido === 0) {
                color = "#008000";
            } else if (pos.sentido === 1) {
                color = "#FF5722";
            } else {
                color = "blue";
            }

            if (this.veiculoSelected === pos.numero_ordem) {
                width = "40";
                height = "40";
            } else {
                width = "30";
                height = "30";
            }

            return L.divIcon({
                className: 'my_custom_pin',
                html: `<svg width="${width}" height="${height}" viewBox="0 0 24 24" fill="#FFFFFF" xmlns="http://www.w3.org/2000/svg"><title>${pos.numero_ordem}</title>
                        <path opacity="0.1" d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" fill="${color}"/>
                        <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="${color}" stroke-width="2"/>
                        <path d="M15 13L12.2014 10.2014V10.2014C12.0901 10.0901 11.9099 10.0901 11.7986 10.2014V10.2014L9 13" stroke="${color}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>`,
                iconAnchor: [15, 15],
                tooltipAnchor: [0, -15]
            });
        },
        veiculoClicked(ordem) {
            if (this.veiculoSelected === ordem) {
                this.veiculoSelected = null;
            } else {
                this.veiculosSelected = ordem;
            }
        },
        onCercaChanged() {
            if (!this.map) {
                return;
            }

            if (this.cercaSelected) {
                this.map.removeControl(this.drawControl);
                if (this.drawnItems) {
                    this.drawnItems.clearLayers();
                }
                let cercaObject = this.cercas.find((c) => this.cercaSelected === c.id_cerca);
                if (cercaObject) {
                    if (this.cercaLayer) {
                        this.map.removeLayer(this.cercaLayer);
                    }
                    this.cercaLayer = new L.GeoJSON(cercaObject.geojson);
                    this.cerca = {
                        type: 'Polygon',
                        center: null,
                        radius: null,
                        points: cercaObject.geojson.geometry.coordinates[0]
                    };
                    this.map.addLayer(this.cercaLayer);
                    this.currentCenter = [cercaObject.lat_centro, cercaObject.lng_centro];
                }
            } else {
                this.map.addControl(this.drawControl);
                if (this.cercaLayer) {
                    this.map.removeLayer(this.cercaLayer);
                }
            }
        },
        searchAddress(local) {
            if (!this.map) {
                this.map = this.$refs.map.mapObject;
            }

            if (local) {
                if (this.searchMarker) {
                    this.map.removeLayer(this.searchMarker);
                }
                this.searchMarker = local.marker;
                this.map.addLayer(this.searchMarker);
                this.searchMarker.openPopup();
                this.currentCenter = [this.searchMarkerPos.lat, this.searchMarkerPos.lng];
            }
            let parametro = {
                dt_registro: DateUtils.getDateSQLFormatted(new Date()),
                valor: 1
            }
            apiController.request(apiController.endpoints.updateChamadashereapi, {
                data: parametro,
            });
        },
        removeSearchMarker() {
            if (!this.map) {
                this.map = this.$refs.map.mapObject;
            }

            if (this.searchMarker) {
                this.map.removeLayer(this.searchMarker);
            }
        },
    },
}
</script>

<style></style>